import React, { useState, useEffect } from 'react';

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

import ListView from '../../Common/Views/ListView';
import InventoryTransactionsList from '../Transactions/InventoryTransactionsList';

const InventoryStockList = ({
    filters = {},
    addButton = true,

    columns = null, // array if specific columns from the columnsConfig to show in the list view. If null, all columns will be shown.

    searchBox = true, // whether to show the search box
    searchAttributes = [
        { name: 'itemName', label: 'Item name', type: 'text' },
        { name: 'itemCode', label: 'Item code (sku)', type: 'text' },
    ],

    noResultsMessage = "No inventory stock found",

    onSelect = null,
}) => {

    const [openTransactionsModal, setOpenTransactionsModal] = useState(false);
    const [selectedStockId, setSelectedStockId] = useState(null);

    const handleSelect = (item) => {
        console.log("Inventory stock selected:", item);
        if (onSelect) {
            onSelect(item);
            return;
        }
        setSelectedStockId(item.id);
        setOpenTransactionsModal(true);
    };

    // Columns configuration for rendering inventory stock list
    const columnsConfig = {
        itemName: {
            key: 'itemName',
            label: 'Item name',
            render: row => row.item?.name
        },
        itemCode: {
            key: 'itemCode',
            label: 'Item Code (sku)',
            render: row => row.item?.code
        },
        locationName: {
            key: 'locationName',
            label: 'Location name',
            render: row => row.location?.name
        },
        locationphoneNumber: {
            key: 'locationphoneNumber',
            label: 'Location phone number',
            render: row => row.location?.phoneNumber
        },
        actualQuantity: {
            key: 'actualQuantity',
            label: 'Actual quantity',
            render: row => `${row.actualQuantity} (${row.item?.uom})`
        },
        reservedQuantity: {
            key: 'reservedQuantity',
            label: 'Reserved quantity',
            render: row => `${row.reservedQuantity} (${row.item?.uom})`
        },
        availableQuantity: {
            key: 'availableQuantity',
            label: 'Available quantity',
            render: row => <Chip label={`${row.availableQuantity} ${row.item?.uom}`} color={row.availableQuantity > 0 ? "success" : "warning"} />
        },
    };


    return (
        <>
            <ListView
                title="Inventory stocks"
                apiPath="/tenants/inventory/stocks"
                filters={filters}

                addButton={addButton}
                addButtonLabel="Add new stock"
                addPath="/inventory/stocks/add"

                rowClickPath={(item) => `/inventory/stock/${item.id}`}
                onSelect={handleSelect}

                columnsConfig={columnsConfig}
                columns={columns}

                searchBox={searchBox}
                searchAttributes={searchAttributes}

                noResultsMessage={noResultsMessage}
            />


            {/* To display the transactions list per selected stock */}
            <Modal
                open={openTransactionsModal}
                onClose={() => {
                    setOpenTransactionsModal(false);
                    setSelectedStockId(null);
                }}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    p: { xs: 1, sm: 2 },
                }}
            >
                <Box
                    sx={{
                        bgcolor: "background.paper",
                        borderRadius: 2,
                        boxShadow: 24,
                        p: { xs: 1, sm: 2 },
                        width: { xs: '95%', sm: '90%', md: '80%', lg: '70%' },
                        maxHeight: "90vh",
                        overflowY: "auto",
                    }}
                >
                    <InventoryTransactionsList
                        filters={{
                            inventoryStockId: selectedStockId
                        }}

                        columns={['locationName', 'itemName', 'transactionType', 'quantity', 'date']}

                        searchBox={false}
                    />
                </Box>
            </Modal>
        </>
    )
};

export default InventoryStockList;